import React from 'react';
import {useNavigate} from 'react-router-dom';
import {Button, Card, Form, Input, Row, Col, Spin} from 'antd';

import PageTitle from '../../../components/page/PageTitle';
import {messageType, showMessages} from '../../../helpers/message';
import {useAppSelector} from '../../../hooks/useStore';
import {useLazyGetSelectMemberQuery} from '../../../store/api/accountApi';
import {selectAccountMembershipNumber} from '../../../store/slices/userSlice';
import {BaseError} from '../../../types/apiTypes';
import {SelectMemberParams} from '../../../types/accountTypes';

import './MemberSelect.less';

const MemberSelect = () => {
    const [form] = Form.useForm();
    const navigate = useNavigate();

    const accountMembershipNumber = useAppSelector(selectAccountMembershipNumber);
    const [selectMember, {isLoading, isSuccess: selectSuccess, isError, error}] = useLazyGetSelectMemberQuery();

    const handleFinish = (values: SelectMemberParams) => {
        selectMember(values);
    }

    React.useEffect(() => {
        if (accountMembershipNumber && selectSuccess) {
            showMessages("You've selected member " + accountMembershipNumber, messageType.success);
            navigate('/account/account_info');
        }

        if (error && isError) {
            showMessages((error as BaseError).data?.message, messageType.error);
        }

    }, [accountMembershipNumber, selectSuccess, error, isError, navigate]);

    return (
        <Spin spinning={isLoading}>
            <PageTitle title="Select Member"/>
            <Row>
                <Col xs={24} sm={16} md={16} lg={16}>
                    <Card title="Select an Account">
                        <Form
                            form={form}
                            name="membership-select"
                            onFinish={handleFinish}
                            layout="vertical"
                            requiredMark={false}
                        >
                            <Row justify='space-between'>
                                <Col xs={24} sm={24} md={16} lg={16}>
                                    <Form.Item
                                        name="account_membership_number"
                                        label="Account Membership Number"
                                        rules={[{
                                            required: true,
                                            message: "'Account Membership Number' is required",
                                            whitespace: true
                                        }]}
                                        className="member-select-input"
                                    >
                                        <Input
                                            placeholder="Type account number here"
                                        />
                                    </Form.Item>
                                </Col>
                                <Col style={{alignContent: 'end'}} xs={24} sm={24} md={8} lg={8}>
                                    <Form.Item className="member-select-button">
                                        <Button type="primary" htmlType="submit">
                                            Select Account
                                        </Button>
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Form>
                    </Card>
                </Col>
            </Row>
        </Spin>
    );
}

export default MemberSelect;
